import React from "react"
import { useTranslation } from "react-i18next"
import { FiUpload } from "react-icons/fi"

export default (args) => {
  const { t } = useTranslation()

  let inputAttrs = args
  return (
    <div
      className="relative w-full h-32 mb-10 bg-[rgba(57,57,57,.5)] 
     shadow-inner outline-none rounded-xl border border-[#B3B3B3]"
    >
      <input
        {...inputAttrs}
        value=""
        type="file"
        id="file-upload"
        className="hidden"
      />
      <label
        htmlFor="file-upload"
        className="z-20 flex flex-col-reverse items-center justify-center w-full h-full cursor-pointer"
      >
        <p className="z-10 text-xs font-light text-center text-white">
          {t("image-upload")}
        </p>
        <FiUpload />
      </label>
    </div>
  )
}
